import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
const antIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />

const Loading = () => {
  return (
    <div className='flex justify-start h-100 items-center font-medium flex-col bg-[url("./assets/images/auth_background.png")]'>
      <Spin indicator={antIcon} />
      <span className='text-rw-color text-xl font-semibold pt-6'> Loading... </span>
    </div>
  )
}
export default Loading
